import {
  activate,
  create,
  getById,
  getList,
  queryEditActive,
  remove,
  setDefault,
  toImportExcel,
  update,
  updateById /* , userReset, queryApiDataPost */,
} from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { getIntl } from 'umi';

export const initialPagination = { page: 1, count: 0, totalPages: 0 };
export const initialState = {
  data: [],
  orderBy: '',
  searchCriteria: '',
  pagination: initialPagination,
  filterDropdownValues: {},
  filters: {},
  filter: '',
  item: null,
  moreEntities: {},
  validationErrors: [],
  showDetail: false,
  showPermissionForm: false,
  userListPermission: [],
  positionListPermission: [],
  userGroupListPermission: [],
  areaListPermission: [],
  showImport: false,
  importError: false,
  errorMessage: '',
  errors: [],
  isConfig: false,
};

export const makeListEffects = ({ namespace, fetchRoute, fetchParams, fetchMoreEntities }) => ({
  *fetchData({ payload }, { call, put, select }) {
    try {
      const pagination = yield select((state) => state[namespace].pagination);
      const pageSize = yield select((state) => state.global.pageSize);
      const res = yield call(getList, {
        route: payload.route ? payload.route : `${fetchRoute}/paged`,
        params: {
          pageSize,
          ...CoreQueries[fetchParams].paged,
          ...pagination,
          ...payload,
        },
        readPriority: true,
      });

      yield put({
        type: 'queryData',
        payload: { ...res, limit: pageSize, page: payload.page },
      });
    } catch (e) {}
  },

  *fetchExport({ payload, onComplete }, { call, put }) {
    const { route, params } = payload;
    try {
      const res = yield call(getList, { route, params });
      onComplete(res);
    } catch (e) {}
  },

  *fetchItem({ payload }, { call, put }) {
    try {
      yield put({ type: 'success', payload: false });
      const res = yield call(getById, {
        route: fetchRoute,
        id: payload.id,
        params: payload.detail
          ? CoreQueries[fetchParams]?.itemDetail
          : { ...CoreQueries[fetchParams]?.item, ...(payload?.params && { ...payload.params }) },
      });
      yield put({ type: 'queryItem', payload: res });
    } catch (e) {}
  },

  *fetchItemAll({ payload }, { call, put }) {
    try {
      yield put({ type: 'success', payload: false });
      const res = yield call(getList, {
        route: payload.route ? payload.route : fetchRoute,
        params: {
          ...fetchParams.item,
          ...payload.params,
        },
      });
      yield put({ type: 'queryDataAll', payload: res });
    } catch (e) {}
  },

  *fetchCreate({ payload }, { put, call }) {
    try {
      yield put({ type: 'success', payload: { success: false } });
      const res = yield call(create, payload);
      yield put({
        type: 'success',
        payload: { ...res, success: true },
      });

      yield put({
        type: 'global/showNotificationsGlobal',
        payload: { visible: true, type: 'success' },
      });
    } catch (e) {
      if (e?.message) {
        if (e.validationErrors && _.isEmpty(e.validationErrors[0].field)) {
          _.set(e, 'message', e.validationErrors[0].errorMessages[0]);
        }

        yield put({
          type: 'global/showNotificationsForm',
          payload: { visible: true, type: 'error', message: e.message },
        });

        yield put({
          type: 'errors',
          payload: {
            validationErrors: e.validationErrors || [],
            message: e.message,
          },
        });
      }
    }
  },

  *fetchUpdate({ payload }, { put, call }) {
    try {
      yield put({ type: 'success', payload: { success: false } });
      const res = yield call(update, { route: fetchRoute, ...payload });
      yield put({
        type: 'success',
        payload: { ...res, success: true },
      });
    } catch (e) {
      if (e?.message) {
        if (e.validationErrors && _.isEmpty(e.validationErrors[0].field)) {
          _.set(e, 'message', e.validationErrors[0].errorMessages[0]);
        }

        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'error',
            message: e.message,
          },
        });

        yield put({
          type: 'errors',
          payload: {
            validationErrors: e.validationErrors || [],
            message: e.message,
          },
        });
      }
    }
  },

  *fetchUpdateBy({ payload }, { put, call }) {
    try {
      yield put({ type: 'success', payload: { success: false } });
      const res = yield call(updateById, payload);
      yield put({
        type: 'success',
        payload: { ...res, success: true },
      });
    } catch (e) {
      if (e?.message) {
        if (e.validationErrors && _.isEmpty(e.validationErrors[0].field)) {
          _.set(e, 'message', e.validationErrors[0].errorMessages[0]);
        }

        yield put({
          type: 'errors',
          payload: {
            validationErrors: e.validationErrors || [],
            message: e.message,
          },
        });
      }
    }
  },

  *setActive({ payload }, { call, put }) {
    try {
      yield call(updateById, {
        route: payload.route,
        id: `${payload.id}/${payload.isActive}`,
        method: 'post',
      });
      yield put({ type: 'queryActive', payload });
    } catch (error) {}
  },

  *showForm({ payload }, { put }) {
    yield put({ type: 'queryShowForm', payload });
    if (!_.isNil(payload.id)) {
      yield put({ type: 'editOrDetail', payload });
    }
  },
  *openView({ payload }, { put }) {
    yield put({ type: 'queryOpenView', payload });
  },

  *showAdditionalForm({ payload }, { put }) {
    yield put({ type: 'queryShowAdditionalForm', payload });
  },

  *fetchFilterDropdownValues({ payload }, { call, put }) {
    try {
      let res;
      // if (payload.name === 'salesChannel') {
      // 	res = _.keys(SaleChannelEnum).map((k) => {
      // 		return {
      // 			id: k,
      // 			name: getIntl().formatMessage({ id: `global.text.${_.camelCase(k)}` }),
      // 		};
      // 	});
      // } else {
      res = yield call(getList, { route: payload.name, params: { select: 'id,name' } });
      //}
      yield put({ type: 'queryFilterDropdownValues', payload: { res, name: payload.name } });
    } catch (e) {}
  },

  *fetchFilterDropdownValuesFromEntities({ payload }, { call, put }) {
    const { names } = payload;
    try {
      for (const name of names) {
        const entityToFetch = fetchMoreEntities.find((entity) => entity.name === name);
        if (!entityToFetch) continue;

        const res = yield call(getList, {
          route: entityToFetch.route,
          params: entityToFetch.params,
        });

        yield put({
          type: 'queryFilterDropdownValues',
          payload: { res, name },
        });
      }
    } catch (e) {}
  },

  *fetchMoreEntities({ payload }, { call, put }) {
    try {
      for (const name of payload.names) {
        const entityToFetch = fetchMoreEntities.find((entity) => entity.name === name);
        if (!entityToFetch) continue;

        const res = yield call(getList, {
          route: entityToFetch.route,
          params: entityToFetch.params,
        });

        yield put({
          type: 'queryFetchMoreEntities',
          payload: { ...entityToFetch, res, name },
        });
      }
    } catch (e) {}
  },
  *fetchDelete({ payload, onComplete }, { put, call }) {
    try {
      yield put({
        type: `global/modalConfirm`,
        payload: { state: false, id: null },
      });

      yield call(remove, { ...payload, route: fetchRoute });
      yield put({ type: 'success', payload: { success: true } });
      yield put({
        type: 'global/showNotificationsGlobal',
        payload: { visible: true, type: 'success' },
      });

      onComplete();
    } catch (error) {}
  },

  *fetchActivate({ payload }, { put, call }) {
    try {
      yield call(activate, { ...payload, route: fetchRoute });
      yield put({
        type: 'success',
        payload: {
          success: true,
        },
      });
    } catch (error) {
      /*  */
    }
  },
  // *fetchUserReset({ payload }, { put, call }) {
  // 	try {
  // 		yield call(userReset, {...payload});
  // 		yield put({
  // 			type: 'success',
  // 			payload: {
  // 				success: true,
  // 			},
  // 		});
  // 	} catch (error) {
  // 		/*  */
  // 	}
  // },

  *setSelectDateValue({ payload }, { put }) {
    yield put({ type: 'setDateValue', payload });
  },

  *setDefault({ payload }, { put, call }) {
    try {
      yield call(setDefault, { ...payload, route: fetchRoute });
      yield put({
        type: 'success',
        payload: {
          success: true,
        },
      });
    } catch (error) {}
  },

  *changeSuccess({ payload }, { put }) {
    yield put({ type: 'success', payload });
  },

  *setPaginationPage({ payload }, { put }) {
    yield put({ type: 'queryPaginationPage', payload });
  },

  // start Permission
  *fetchListPermissions({ payload }, { call, put }) {
    try {
      const userListPermission = yield call(getList, {
        route: `${fetchRoute}/allowedUsers/${payload.id}`,
        params: CoreQueries['UserPosition'],
      });

      const positionListPermission = yield call(getList, {
        route: `${fetchRoute}/allowedPositions/${payload.id}`,
        params: CoreQueries['NameAndDescription'],
      });

      const areaListPermission = yield call(getList, {
        route: `${fetchRoute}/allowedAreas/${payload.id}`,
        params: CoreQueries['NameAndDescription'],
      });

      const userGroupListPermission = yield call(getList, {
        route: `${fetchRoute}/allowedUserGroups/${payload.id}`,
        params: CoreQueries['NameAndDescription'],
      });

      yield put({
        type: 'queryListPermissions',
        payload: {
          userListPermission,
          positionListPermission,
          areaListPermission,
          userGroupListPermission,
        },
      });
    } catch (e) {}
  },

  *addListPermission({ payload }, { put }) {
    yield put({
      type: 'queryAddListPermission',
      payload,
    });
  },

  *showPermissionForm({ payload }, { put }) {
    yield put({ type: 'queryShowPermissionForm', payload });
  },

  *deleteItemPermision({ payload }, { put }) {
    yield put({ type: 'queryDeleteItemPermision', payload });
    yield put({
      type: `global/modalConfirmDrawer`,
      payload: { state: false, id: null },
    });
  },
  // end Permission

  *setFilterItem({ payload }, { put }) {
    yield put({ type: 'queryFilterItem', payload });
  },
  *setFilterItemDashboard({ payload }, { put }) {
    yield put({ type: 'queryFilterItemDashboard', payload });
  },

  *setOrderBy({ payload }, { put }) {
    yield put({
      type: 'queryOrderBy',
      payload,
    });
  },

  *clearError(__, { put }) {
    yield put({ type: 'queryClearError' });
  },

  *resetState(__, { put }) {
    yield put({ type: 'reset' });
  },

  *fetchImport({ payload }, { call, put, select }) {
    try {
      const { file, isDeleteData } = payload;
      const pageSize = yield select((state) => state.global.pageSize);

      const res = yield call(toImportExcel, {
        route: fetchRoute,
        fileContent: file,
        deleteExistingData: isDeleteData,
      });

      if (res.errorMessage) {
        yield put({ type: 'queryImportErrors', payload: { ...res } });
      } else {
        yield put({ type: 'queryImport', payload: { ...res } });
        yield put({ type: 'fetchData', payload: { page: 1, limit: pageSize, readPriority: true } });
      }
    } catch (error) {
      if (error.message) {
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: false,
            visibleForm: true,
            type: 'error',
            message: error.message,
          },
        });
      }
    }
  },

  *toggleImportComponent({ payload }, { put }) {
    yield put({
      type: 'queryToggleImportComponent',
      payload: { showImport: payload.show },
    });
  },

  *editActive({ payload, params }, { call, put }) {
    try {
      yield call(queryEditActive, { id: params, route: fetchRoute });
      yield put({
        type: 'editActives',
        payload,
      });
    } catch (e) {}
  },
  *openDrawerView({ payload }, { put }) {
    yield put({
      type: 'queryOpenDrawerView',
      payload,
    });
  },
  *clearImportErrors(__, { put }) {
    yield put({ type: 'clearImportErrors' });
  },
});

export const makeListReducers = ({ initialPagination, initialState }) => ({
  queryPaginationPage(state, { payload }) {
    return {
      ...state,
      pagination: { ...state.pagination, page: payload },
    };
  },

  queryFilterItem(state, { payload }) {
    const newFilters = {
      ...state.filters,
      [payload.name]: payload.filters.map((filter) => {
        if (payload.addIdSuffix) {
          if (payload.name === 'store/allowed') {
            if (payload.match) return `storeId eq ${filter}`;
            return `order/storeId eq ${filter}`;
          }
          if (payload.match) return `${payload.match} eq ${filter}`;

          return `${payload.name}/id eq ${filter}`;
        }

        return filter;
      }),
    };

    return {
      ...state,
      filters: newFilters,
      filter: Object.values(newFilters)
        .filter((filter) => filter.length > 0)
        .map((filter) =>
          filter.map((filter, index) => (index === 0 ? filter : `(${filter})`)).join(' or '),
        )
        .map((item) => `(${item})`)
        .join(' and '),
      pagination: {
        ...state.pagination,
        currentPage: initialPagination.currentPage,
      },
    };
  },

  queryFilterItemDashboard(state, { payload }) {
    const newFilters = {
      ...state.filters,
      [payload.name]: payload.filters.map((filter) => {
        return filter;
      }),
    };

    return {
      ...state,
      filters: newFilters,
      filter: newFilters,
    };
  },

  queryData(state, { payload }) {
    return {
      ...state,
      list: payload.items,
      pagination: _.merge(state.pagination, toPaginate(payload)),
      // data: payload.items,
      // pagination: {
      // 	...state.pagination,
      // 	totalCount: payload.totalCount,
      // 	totalPages: payload.pageSize ? Math.ceil(payload.totalCount / payload.pageSize) : 0,
      // 	currentPage:
      // 		state.pagination.latestPageSize !== payload.pageSize
      // 			? initialPagination.currentPage
      // 			: state.pagination.currentPage,
      // 	latestPageSize: payload.pageSize,
      // },
    };
  },

  queryDataAll(state, { payload }) {
    return {
      ...state,
      data: [...payload],
    };
  },

  queryActivate(state, { payload }) {
    return {
      ...state,
      data: payload.items,
    };
  },

  queryItem(state, { payload }) {
    return {
      ...state,
      item: payload,
    };
  },

  queryFilterDropdownValues(state, { payload }) {
    return {
      ...state,
      filterDropdownValues: {
        ...state.filterDropdownValues,
        [payload.name]: payload.res,
      },
    };
  },

  queryFetchMoreEntities(state, { payload }) {
    return {
      ...state,
      moreEntities: {
        ...state.moreEntities,
        [payload.name]: {
          labelSource: payload.labelSource,
          content: payload.res,
        },
      },
    };
  },

  queryOrderBy(state, { payload }) {
    return {
      ...state,
      orderBy: payload,
    };
  },

  search(state, { payload }) {
    return {
      ...state,
      searchCriteria: payload,
      pagination: {
        ...state.pagination,
        currentPage: initialPagination.currentPage,
      },
    };
  },

  queryShowForm(state, { payload }) {
    return {
      ...state,
      showForm: payload.state,
      openView: payload.state ? false : state.openView,
      detail: payload.detail,
      id: payload.id,
      success: false,
      validationErrors: [],
      item: null,
      isConfig: payload.isConfig,
      connectionType: payload.connectionType,
    };
  },
  queryOpenView(state, { payload }) {
    return {
      ...state,
      openView: payload.state,
      showForm: payload.state ? false : state.showForm,
      detail: payload.detail,
      id: payload.id,
      success: false,
      validationErrors: [],
      item: null,
    };
  },

  queryShowAdditionalForm(state, { payload }) {
    return {
      ...state,
      showAdditionalForm: payload.state,
      detail: payload.detail,
      id: payload.id,
      success: false,
      validationErrors: [],
      item: null,
    };
  },

  editOrDetail(state, { payload }) {
    return {
      ...state,
      item: {},
    };
  },

  queryActive(state, { payload }) {
    const data = [...state.data];
    const index = _.findIndex(data, { id: payload.id });

    if (index >= 0) {
      Object.assign(data, {
        [index]: {
          ...data[index],
          isActive: payload.isActive,
        },
      });
    }

    return {
      ...state,
      data,
    };
  },

  errors(state, { payload }) {
    return {
      ...state,
      validationErrors: payload.validationErrors,
      message: payload.message,
    };
  },

  setDateValue(state, { payload }) {
    return {
      ...state,
      dateValue: payload.value,
    };
  },

  success(state, { payload }) {
    return {
      ...state,
      ...payload,
      success: payload.success,
      validationErrors: [],
    };
  },

  queryClearError(state) {
    return {
      ...state,
      errorMessage: null,
      validationErrors: [],
      errors: null,
    };
  },

  //start permissions
  queryShowPermissionForm(state, { payload }) {
    return {
      ...state,
      showPermissionForm: payload.state,
      showForm: payload.false,
      id: payload.id,
    };
  },

  queryListPermissions(state, { payload }) {
    return {
      ...state,
      userListPermission: payload.userListPermission,
      positionListPermission: payload.positionListPermission,
      userGroupListPermission: payload.userGroupListPermission,
      areaListPermission: payload.areaListPermission,
    };
  },

  queryAddListPermission(state, { payload }) {
    return {
      ...state,
      [payload.name]: [...state[payload.name], payload.data],
    };
  },
  queryDeleteItemPermision(state, { payload }) {
    return {
      ...state,
      [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
    };
  },

  hidePermission(state, { payload }) {
    return {
      ...state,
      showPermissionForm: false,
      id: null,
      userListPermission: [],
      positionListPermission: [],
      userGroupListPermission: [],
      areaListPermission: [],
    };
  },

  queryImport(state) {
    return {
      ...state,
      showImport: false,
      errorMessage: null,
      errors: null,
    };
  },
  queryImportErrors(state, { payload }) {
    return {
      ...state,
      importError: true,
      errorMessage: payload.errorMessage,
      errors: payload.errors,
    };
  },
  clearImportErrors(state) {
    return {
      ...state,
      errorMessage: null,
      errors: null,
    };
  },

  queryToggleImportComponent(state, { payload }) {
    return {
      ...state,
      ...payload,
    };
  },

  //end permissions

  reset() {
    return initialState;
  },

  editActives(state, { payload }) {
    const list = state.list.map((item) => (item.id === payload.id ? payload : item));
    return {
      ...state,
      list,
    };
  },
  queryOpenDrawerView(state, { payload }) {
    return {
      ...state,
      id: payload.id,
      openView: payload.state,
      selectedItem: {},
      view: payload.view,
    };
  },
});
